import BillingDashboard from "@/components/BillingDashboard/BillingDashboard.vue";
import BuyQuoteEditForm from "@/components/BuyQuotes/BuyQuoteEditForm.vue";
import Calendar from "@/components/Schedule/Calendar.vue";
import CalendarFeedCreate from "@/components/CalendarFeeds/CalendarFeedCreate.vue";
import ClientEditForm from "@/components/Clients/ClientEditForm.vue";
import ClientFieldEditForm from "@/components/ClientFields/ClientFieldEditForm.vue";
import ClientFieldShow from "@/components/ClientFields/ClientFieldShow.vue";
import ClientFields from "@/components/ClientFields/ClientFields.vue";
import ClientShow from "@/components/Clients/ClientShow.vue";
import Clients from "@/components/Clients/Clients.vue";
import Commodities from "@/components/Commodities/Commodities.vue";
import CommodityEditForm from "@/components/Commodities/CommodityEditForm.vue";
import CreateWorkOrderForm from "@/components/WorkOrders/CreateWorkOrderForm.vue";
import FWFinishWorkOrderTaskForm from "@/components/FWWorkOrders/FinishWorkOrderTaskForm.vue";
import FWWorkOrderNotes from "@/components/FWWorkOrders/WorkOrderNotes.vue";
import FWWorkOrderShow from "@/components/FWWorkOrders/WorkOrderShow.vue";
import FWWorkOrderTaskShow from "@/components/FWWorkOrders/WorkOrderTaskShow.vue";
import FinishWorkOrderTaskForm from "@/components/WorkOrders/FinishWorkOrderTaskForm.vue";
import GrindingLoads from "@/components/GrindingLoads/GrindingLoads.vue";
import GrindingLoadEditForm from "@/components/GrindingLoads/GrindingLoadEditForm.vue";
import Home from "./views/Home.vue";
import LineItemEditForm from "@/components/LineItems/LineItemEditForm.vue";
import LineItems from "@/components/LineItems/LineItems.vue";
import LogIn from "@/components/Session/LogIn.vue";
import LotUnitEditForm from "@/components/LotUnits/LotUnitEditForm.vue";
import LotUnits from "@/components/LotUnits/LotUnits.vue";
import ProductivityDashboard from "@/components/ProductivityDashboard/ProductivityDashboard.vue";
import TemplateWorkOrderEditForm from "@/components/TemplateWorkOrders/TemplateWorkOrderEditForm.vue";
import TemplateWorkOrderLotEditForm from "@/components/TemplateWorkOrders/TemplateWorkOrderLotEditForm.vue";
import TemplateWorkOrderLots from "@/components/TemplateWorkOrders/TemplateWorkOrderLots.vue";
import TemplateWorkOrderShow from "@/components/TemplateWorkOrders/TemplateWorkOrderShow.vue";
import TemplateWorkOrderTaskEditForm from "@/components/TemplateWorkOrders/TemplateWorkOrderTaskEditForm.vue";
import TemplateWorkOrderTaskLineItemEditForm from "@/components/TemplateWorkOrders/TemplateWorkOrderTaskLineItemEditForm.vue";
import TemplateWorkOrderTasks from "@/components/TemplateWorkOrders/TemplateWorkOrderTasks.vue";
import TemplateWorkOrders from "@/components/TemplateWorkOrders/TemplateWorkOrders.vue";
import UserEditForm from "@/components/Users/UserEditForm.vue";
import Users from "@/components/Users/Users.vue";
import Vue from "vue";
import VueRouter from "vue-router";
import WorkOrderAttachmentEditForm from "@/components/WorkOrders/WorkOrderAttachmentEditForm.vue";
import WorkOrderAttachments from "@/components/WorkOrders/WorkOrderAttachments.vue";
import WorkOrderDetails from "@/components/WorkOrders/WorkOrderDetails.vue";
import WorkOrderEditForm from "@/components/WorkOrders/WorkOrderEditForm.vue";
import WorkOrderInstructionEditForm from "@/components/WorkOrders/WorkOrderInstructionEditForm.vue";
import WorkOrderInstructions from "@/components/WorkOrders/WorkOrderInstructions.vue";
import WorkOrderLotEditForm from "@/components/WorkOrders/WorkOrderLotEditForm.vue";
import WorkOrderLots from "@/components/WorkOrders/WorkOrderLots.vue";
import WorkOrderNotes from "@/components/WorkOrders/WorkOrderNotes.vue";
import WorkOrderPrint from "@/components/WorkOrders/WorkOrderPrint.vue";
import WorkOrderShow from "@/components/WorkOrders/WorkOrderShow.vue";
import WorkOrderTaskEditForm from "@/components/WorkOrders/WorkOrderTaskEditForm.vue";
import WorkOrderTaskLineItemEditForm from "@/components/WorkOrders/WorkOrderTaskLineItemEditForm.vue";
import WorkOrderTasks from "@/components/WorkOrders/WorkOrderTasks.vue";
import WorkOrders from "@/components/WorkOrders/WorkOrders.vue";
import WorkQueue from "@/components/WorkQueue/WorkQueue.vue";
// needed to check if user is logged in
import store from "./store/index";

Vue.use(VueRouter);
const allPermissionLevels = ["admin", "field_worker", "office_worker"];

let router = new VueRouter({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/log-in",
      name: "logIn",
      component: LogIn,
      meta: {
        requiresAuth: false,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/buy-quote-edit/:buyQuoteId",
      name: "buyQuoteEditForm",
      component: BuyQuoteEditForm,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/work-queue",
      name: "workQueue",
      component: WorkQueue,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/clients",
      name: "clients",
      component: Clients,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/calendar",
      name: "calendar",
      component: Calendar,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/calendar-feed",
      name: "calendarFeedCreate",
      component: CalendarFeedCreate,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/client-show/:clientId",
      name: "clientShow",
      component: ClientShow,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/client-edit/:clientId",
      name: "clientEditForm",
      component: ClientEditForm,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/commodities",
      name: "commodities",
      component: Commodities,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/commodity-edit/:commodityId",
      name: "commodityEditForm",
      component: CommodityEditForm,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/grinding-loads",
      name: "grindingLoads",
      component: GrindingLoads,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/grinding-load-edit/:grindingLoadId",
      name: "grindingLoadEditForm",
      component: GrindingLoadEditForm,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/line-items",
      name: "lineItems",
      component: LineItems,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/line-item-edit/:lineItemId",
      name: "lineItemEditForm",
      component: LineItemEditForm,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/lot-units",
      name: "lotUnits",
      component: LotUnits,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/lot-unit-edit/:lotUnitId",
      name: "lotUnitEditForm",
      component: LotUnitEditForm,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/billing-dashboard",
      name: "billingDashboard",
      component: BillingDashboard,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/productivity-dashboard",
      name: "productivityDashboard",
      component: ProductivityDashboard,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/users",
      name: "users",
      component: Users,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/user-edit/:userId",
      name: "userEditForm",
      component: UserEditForm,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/client-fields",
      name: "clientFields",
      component: ClientFields,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/client-field-show/:clientFieldId",
      name: "clientFieldShow",
      component: ClientFieldShow,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/client-field-edit/:clientFieldId",
      name: "clientFieldEditForm",
      component: ClientFieldEditForm,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/fw/work-order-show/:workOrderId",
      name: "fwWorkOrderShow",
      component: FWWorkOrderShow,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
      children: [
        {
          path: "task-show/:workOrderTaskId",
          name: "fwWorkOrderTaskShow",
          component: FWWorkOrderTaskShow,
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "finish-work-order-task/:workOrderTaskId",
          name: "fwFinishWorkOrderTaskForm",
          component: FWFinishWorkOrderTaskForm,
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "notes",
          name: "fwWorkOrderNotes",
          component: FWWorkOrderNotes,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
      ],
    },
    {
      path: "/work-orders",
      name: "workOrders",
      component: WorkOrders,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/work-order-print/:workOrderId",
      name: "workOrderPrint",
      component: WorkOrderPrint,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/work-order-show/:workOrderId",
      name: "workOrderShow",
      component: WorkOrderShow,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
      children: [
        {
          path: "notes",
          name: "workOrderNotes",
          component: WorkOrderNotes,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "tasks",
          name: "workOrderTasks",
          component: WorkOrderTasks,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "lots",
          name: "workOrderLots",
          component: WorkOrderLots,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "details",
          name: "workOrderDetails",
          component: WorkOrderDetails,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "attachments",
          name: "workOrderAttachments",
          component: WorkOrderAttachments,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "attachment-edit/:workOrderAttachmentId",
          name: "workOrderAttachmentEditForm",
          component: WorkOrderAttachmentEditForm,
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "lot-edit/:workOrderLotId",
          name: "workOrderLotEditForm",
          component: WorkOrderLotEditForm,
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "task-edit/:workOrderTaskId",
          name: "workOrderTaskEditForm",
          component: WorkOrderTaskEditForm,
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "task/:taskId/line-item-edit/:lineItemId",
          name: "workOrderTaskLineItemEditForm",
          component: WorkOrderTaskLineItemEditForm,
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "instructions",
          name: "workOrderInstructions",
          component: WorkOrderInstructions,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "instruction-edit/:workOrderInstructionId",
          name: "workOrderInstructionEditForm",
          component: WorkOrderInstructionEditForm,
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
      ],
    },
    {
      path: "/finish-work-order-task/:workOrderTaskId",
      name: "finishWorkOrderTaskForm",
      component: FinishWorkOrderTaskForm,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/work-order-edit/:workOrderId",
      name: "workOrderEditForm",
      component: WorkOrderEditForm,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/create-work-order",
      name: "createWorkOrderForm",
      component: CreateWorkOrderForm,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/template-work-orders",
      name: "templateWorkOrders",
      component: TemplateWorkOrders,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/template-work-order-show/:templateWorkOrderId",
      name: "templateWorkOrderShow",
      component: TemplateWorkOrderShow,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
      children: [
        {
          path: "lots",
          name: "templateWorkOrderLots",
          component: TemplateWorkOrderLots,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "lot-edit/:templateWorkOrderLotId",
          name: "templateWorkOrderLotEditForm",
          component: TemplateWorkOrderLotEditForm,
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "tasks",
          name: "templateWorkOrderTasks",
          component: TemplateWorkOrderTasks,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "task/:taskId/line-item-edit/:lineItemId",
          name: "templateWorkOrderTaskLineItemEditForm",
          component: TemplateWorkOrderTaskLineItemEditForm,
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
        {
          path: "task-edit/:templateWorkOrderTaskId",
          name: "templateWorkOrderTaskEditForm",
          component: TemplateWorkOrderTaskEditForm,
          props: true,
          meta: {
            requiresAuth: true,
            allowedPermissionLevels: allPermissionLevels,
          },
        },
      ],
    },
    {
      path: "/template-work-order-edit/:templateWorkOrderId",
      name: "templateWorkOrderEditForm",
      component: TemplateWorkOrderEditForm,
      props: true,
      meta: {
        requiresAuth: true,
        allowedPermissionLevels: allPermissionLevels,
      },
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  let passedLogInCheck = false;
  let passedPermissionLevelCheck = false;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      // passed it and has it
      passedLogInCheck = true;
    } else {
      // needs auth, doesn't have it
      // store the route in the store
      store.dispatch("updateNextPath", to.path);
      passedLogInCheck = false;

      next({
        name: "logIn",
        params: {
          nextUrl: to.fullPath,
        },
      });
      return;
    }
  } else {
    // doesn't need auth
    passedLogInCheck = true;
  }

  const permissionLevel = store.getters.userPermissionLevel;

  if (
    to.matched.every(record => {
      return record.meta.allowedPermissionLevels.includes(permissionLevel);
    })
  ) {
    passedPermissionLevelCheck = true;
  } else {
    passedPermissionLevelCheck = false;
  }

  if (passedLogInCheck && passedPermissionLevelCheck) {
    // navigate
    next();
  }
});

export default router;
